import React from 'react';
import BlogCardStandard from '../../components/BlogElements/BlogCardStandard';
import Pagination from '../../components/common/Pagination';

const Blog1 = () => {
    const BlogData01 = [
        {
            id: '1',
            img: 'images/blog/lg1.jpg',
            date: 'August 26, 2022',
            title: 'How I get my First Michelin Star of My Carrier'
        },
        {
            id: '2',
            img: 'images/blog/lg2.jpg',
            date: 'August 26, 2022',
            title: 'How We run our coffeshop Business'
        },
        {
            id: '3',
            img: 'images/blog/lg3.jpg',
            date: 'August 26, 2022',
            title: 'We are Introducing Indo Chinese Combo'
        },
        {
            id: '4',
            img: 'images/blog/lg4.jpg',
            date: 'August 26, 2022',
            title: 'Our New Recipe, Orange Pancake'
        },
    ];

    return (
        <div className="main-wrapper">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-md-12">
                        <div className="blog_standard">
                            {BlogData01.map(data => <BlogCardStandard
                                key={data.id}
                                data={data}
                            />)}
                        </div>
                        <Pagination />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Blog1;